<template>
  <div>
    <report-release-note></report-release-note>
    <w-table ref="wMyTable" :columns="columns" :table-data="tableData"
             @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
             :table-col-check="{
                  isShow:true,
                  name:'raw_col4'
                }"
             :page="page" @pageChange="handlePagePagination">
      <span slot="projectId" slot-scope="{text,record}">
       <span v-if="judgeProjectLock(record)" >
            <span v-if="judgeProjectLockIcon(record)" class="projectLockIcon">
               <el-tooltip content="分析结果未释放">
                 <a-icon type="lock"/>
               </el-tooltip>
            </span>
            <a @click="getProjectInfo(text)">{{ text }}</a>
       </span>
        <el-tooltip v-else content="分析结果未释放，项目不可查看">
          <span style="cursor:pointer;color: rgba(143,146,153,0.8)"><a-icon class="projectLockIcon"  type="lock"/>{{ text }}</span>
        </el-tooltip>
      </span>
      <!--       折叠-->
      <div slot="foldInfo" slot-scope="{text, record, index}">
        <ex-fold-table-cell :scope="{text:text.split('|'), record, index}"></ex-fold-table-cell>
      </div>
      <span slot="passApproval" slot-scope="{text,record}">
          <el-tag :type="text?'success':'info'">{{ text ? '通过' : '待审批' }}</el-tag>
      </span>
      <span slot="bsSignStatus" slot-scope="{text,record}">
          <div  v-if="text">
            <el-tag :type="['SIGNED','AUTO'].includes(text)?'success':'danger'">{{ bsContractChEn[text] }}</el-tag>
          </div>
        </span>
      <span slot="resReleased" slot-scope="{text,record}">
          <el-tag :type="record?.bsReleased&&record?.resReleased?'success':'info'">{{
              (record?.bsReleased && record?.resReleased) ? '已释放' : '未释放'
            }}</el-tag>
      </span>
      <span slot="customerName" slot-scope="{text,record}">
        {{ text ? Array.from(new Set(text.map(item => item.realName))).join(';') : '' }}
      </span>
      <div slot="note" slot-scope="{text, record,column}">
        <div style="display: flex;align-items: center">
          <el-tooltip content="修改备注">
            <i class="el-icon-edit" style="color: green;cursor: pointer" v-has-permission="'project_edit'"
               @click="handleShowUpdateDialog(record,'note')"></i>
          </el-tooltip>
          <div>
                <span v-html="computerNote(text)">
                </span>
            <el-tooltip content="显示更多信息">
                <span v-if="text?text.length>30:false" @click="handleShowUpdateDialog(record,'note')"
                      style="font-size: 11px;cursor: pointer">......</span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div slot="customNote" slot-scope="{text, record,column}">
        <div style="display: flex;align-items: center">
          <el-tooltip content="修改备注">
            <i class="el-icon-edit" style="color: green;cursor: pointer"
               v-if="record.customerList.map(item=>item.userId).includes($store.getters['right/getUser'].uid)||['ADMIN','MANAGER'].includes($store.getters['right/getRole'])"
               @click="handleShowUpdateDialog(record,'customerRemark')"></i>
          </el-tooltip>
          <div>
                <span v-html="computerNote(text)">
                </span>
            <el-tooltip content="显示更多信息">
                <span v-if="text?text.length>30:false" @click="handleShowUpdateDialog(record,'customerRemark')"
                      style="font-size: 11px;cursor: pointer">......</span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <span slot="salesName" slot-scope="{text,record}">
        {{ text ? text.map(item => item.name).join(';') : '' }}
      </span>
<!--      <div slot="rawDataStatus" slot-scope="{text}">-->
<!--           <span :class="rawDataStatusIconList[text]?.class">-->
<!--            {{ rawDataStatusIconList[text].displayName }}-->
<!--          </span>-->
<!--      </div>-->
      <div slot="rawDataStatus" slot-scope="{text,record}">
        <project-raw-release-info  :select-detail="record" @lookSampleInfo="lookSampleInfo"
                                  @downloadRawData="handleDownloadRawData"></project-raw-release-info>
      </div>
      <template slot="operation" slot-scope="{text,record}">
        <el-button v-has-permission="'projects_detail'"
                   size="mini"
                   type="success"
                   @click="handleDetail(record)">查看详情
        </el-button>
<!--        <el-button v-if="record.rawDataStatus==='LINK_RELEASED'"-->
<!--                   size="mini"-->
<!--                   type="success"-->
<!--                   @click="handleDownloadRawData(record)">下载原始数据-->
<!--        </el-button>-->
        <el-popconfirm
            confirm-button-text='同意释放'
            cancel-button-text='取消'
            title="你同意释放该项目的原始数据吗？"
            v-if="record.rawDataStatus==='NOT_RELEASED'&&record.soleKey&&record.soleKey.some(item=>item.includes('UNKNOW'))&&['ADMIN', 'MANAGER', 'AUDIT'].includes($store.getters['right/getRole'])"
            @confirm="handleAudit(record)">
          <el-button slot="reference"
                     size="mini"
                     type="info"
                     style="margin-left: 10px">数据审核
          </el-button>
        </el-popconfirm>
        <el-button type="warning" size="mini" v-if="$store.getters['right/getRole']==='AUDIT'"
                   @click="handleChange(record)">
          更改用户
        </el-button>
        <el-button v-has-permission="'project_share'"
                   size="mini"
                   type="primary"
                   @click="handleShare(record)">分享
        </el-button>

        <el-dropdown size="mini" @command="(command) => handleCommand(command, record)"
                     v-if="['ADMIN','MANAGER'].includes($store.getters['right/getRole'])">
          <el-button size="mini" type="warning" style="margin-left: 10px">更多</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="handleChange" icon="el-icon-edit">更换用户</el-dropdown-item>
            <el-dropdown-item command="handleDown" icon="el-icon-download">下载结题报告</el-dropdown-item>
            <el-dropdown-item command="handleShare" icon="el-icon-share">分享</el-dropdown-item>
            <el-dropdown-item command="handleDelete" icon="el-icon-delete">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <div slot="filterRawDataStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
           style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 0px 15px">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label="无原始数据">无原始数据</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label="未释放">未释放</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label="已释放(网盘)">已释放(网盘)</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label="已释放(硬盘)">已释放(硬盘)</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
    </w-table>
    <!--    查看项目详情-->
    <info v-if="openDetail" :formData="detailForm" @closeDetail="closeDetail"></info>
    <!--    编辑项目信息-->
    <edit-project v-if="editProjectDialog" :showDialog="editProjectDialog" :select-detail="selectDetail"
                  @submit="submitEditProject"></edit-project>
    <change-users v-if="showUserDialog" :show-dialog="showUserDialog" :select-detail="updateProjectUserData"
                  @submit="submitProjectUser"></change-users>
    <picture-loading v-if="loading"></picture-loading>
    <!--    xx新建中-->
    <LoadingDialog v-show="isShowAddLoading" :showDialog="isShowAddLoading"
                   :dialogMessage="showAddLoadingMess"></LoadingDialog>
    <!--    分享管理-->
    <share-customer-manager-dialog v-if="showShareCusDialog" :select-detail="selectDetail" platform="RAW"
                                   :show-dialog="showShareCusDialog"
                                   @submit="closeShareCusDialog"></share-customer-manager-dialog>
    <!--    修改项目信息-->
    <edit-form-info-dialog v-if="showUpdateDialog" :show-dialog.sync="showUpdateDialog"
                           :select-detail="updateProjectData"
                           @submitData="updateCustomerRemark"></edit-form-info-dialog>
    <!--    样本信息-->
    <sample-info-dialog v-if="sampleInfoDialog"
                        :show-dialog.sync="sampleInfoDialog"
                        :select-detail="selectDetail"></sample-info-dialog>
    <l-e-down-files-dialog v-if="downRawFilesDialog" :show-dialog.sync="downRawFilesDialog"
                           :downLoadUrl="downLoadRawUrl">
    </l-e-down-files-dialog>
  </div>
</template>

<script>
import {
  addProjectFile,
  auditData,
  changeProjectUser,
  delProject,
  getProject,
  listProject, projectBatchApi, projectCustomerEdit, rawProjectDownloadRawData,
  updateProject
} from "@/api/rawData";
import Info from "@/views/systems/project/rawData/Info";
import ChangeUsers from "@/components/ChangeUsers";
import {getDataInLocalStorage} from "@/utils/localStorage";
import EditProject from "@/components/project/rawData/EditProject";
import {startUploadFile} from "@/utils/uploadFile";
import PictureLoading from "@/components/customerTable/PictureLoading";
import LoadingDialog from "@/components/LoadingDialog";
import {columnsData} from "@/utils/data/tableCol/rawTableCol";
import ExFoldTableCell from "@/components/ExFoldTableCell";
import ShareCustomerManagerDialog from "@/components/ShareCustomerManagerDialog";
import {bsContractChEn, getRawDataStatusChByEn, getRawDataStatusEnByCh, rawDataStatusColor} from "@/utils/ch_en_trans";
import {tableOperationMixin} from "@/mixins/tableOperation";
import {rawDataStatusIconList} from "@/utils/data/basicData/rawDataStatusData";
import EditFormInfoDialog from "@/components/EditFormInfoDialog.vue";
import ReportReleaseNote from "@/components/ReportReleaseNote.vue";
import {getBsInfoByContract} from "@/api/dilivery/bs";
import {getReportLink} from "@/api/rawData/shareCustomer";
import {projectEdit} from "@/api/project";
import RawReleaseInfo from "@/components/RawDataReleaseInfo/RawReleaseInfo.vue";
import SampleInfoDialog from "@/components/SampleInfoDialog.vue";
import {getRawReleaseInfoByProjectSoleKey} from "@/api/dilivery";
import ProjectRawReleaseInfo from "@/components/RawDataReleaseInfo/ProjectRawReleaseInfo.vue";

export default {
  name: "rawData",
  mixins: [tableOperationMixin],
  components: {
    ProjectRawReleaseInfo,
    SampleInfoDialog,
    RawReleaseInfo,
    ReportReleaseNote,
    EditFormInfoDialog,
    ShareCustomerManagerDialog,
    EditProject,
    ChangeUsers,
    Info,
    PictureLoading,
    LoadingDialog,
    ExFoldTableCell
  },
  data() {
    return {
      showUpdateDialog: false,
      updateProjectData: {},
      rawDataStatusIconList: rawDataStatusIconList,
      loading: true,
      isShowAddLoading: false,
      showAddLoadingMess: '文件上传中，请耐心等待.......',
      //分页
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      tableData: [],//表格数据
      searchConditionTag: [],
      sortConditionTag: '',
      showUserDialog: false,//展示更改用户的弹框
      updateProjectUserData: {
        projectId: '',
        selectedSalers: [],
        selectedAnalyze: '',
        selectedCustomers: [],
        selectedCustomersInfo: []
      }, //更改用户的数据（更换分析和销售）
      openDetail: false,//查看详情弹框
      detailForm: {},
      selectDetail: '',
      editProjectDialog: false,
      showShareCusDialog: false,//分享客户管理
      bsContractChEn:bsContractChEn,
      sampleInfoDialog: false,
      downRawFilesDialog: false,
      downLoadRawUrl: '',
    }
  },
  computed: {
    columns() {
      let column = columnsData(this.searchConditionTag || {})
      if (this.$store.getters["right/getRole"] === 'USER') {
        column = column.filter(item => !item.isNeedPermit)
      }
      return column
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(isSearch) {
      this.loading = true
      var param = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
        'order': ''
      }
      if (isSearch === 'search') {
        param['page.size'] = 10
        param['page.current'] = 1
      }
      let sendData = {}
      let length = this.searchConditionTag.length
      if (length) {
        this.searchConditionTag.forEach(item => {
          let key = item.key
          if (key === 'rawDataStatus') {
            sendData[key] = getRawDataStatusEnByCh(item.value)
          } else {
            sendData[key] = item.value
          }
        })
      }
      const res =await listProject(param, sendData)
      if (res.code === 200) {
        const contractInfoRes = await getBsInfoByContract(res.data.records.map(item => item?.contractNumber).filter(item => item))
        let batchSendData = res.data.records.filter(item => ['NOT_RELEASED', 'LINK_RELEASED'].includes(item.rawDataStatus)).map(item => {
          return {
            key: item.id,
            uri: "/raw/project/click/" + item.id,
            method: "GET", "body": {}
          }
        })
        const apiBatchRes = await projectBatchApi(batchSendData)
        var pageData = _.cloneDeep(res.data.records)

        if (contractInfoRes.code === 200) {
          const contractInfo = contractInfoRes.data
          let releaseSendData = (pageData.filter(item => ['NOT_RELEASED','LINK_RELEASED', 'HDD_RELEASED'].includes(item.rawDataStatus)) || []).map(item => {
            let rawLinkInfo = apiBatchRes[item.id]
            return {
              projectSoleKey: item.soleKey[0],
              isHdd: ['HDD_RELEASED'].includes(item.rawDataStatus),
              rawLink: rawLinkInfo?.code === 200 ? rawLinkInfo.data : ''
            }
          })
          const releaseInfoRes = await getRawReleaseInfoByProjectSoleKey(releaseSendData)
          this.tableData = pageData.map(item => {
            return {
              ...item,
              rawInfo: releaseInfoRes.data[item.soleKey[0]] || {},
              bsSignStatus: (contractInfo) ? (contractInfo[item?.contractNumber]?.signStatus) : '',
              projectSoleKey: item.soleKey[0]
            }
          })
          this.loading = false
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    //页码的变动
    handlePagePagination(page) {
      this.loading = true
      this.page.currentNum = page.currentNum
      if (page.pageSize) {
        this.page.pageSize = page.pageSize
      } else {
        this.page.pageSize = this.page.total
      }
      this.getData()
    },
    //获取原始数据状态
    getRawStatus(status) {
      return getRawDataStatusChByEn(status)
    },
    //获取原始数据状态tag颜色
    getRawStatusColor(status) {
      return rawDataStatusColor[status]
    },
    //项目详情
    handleDetail(row) {
      const id = row.id
      getProject(id).then(response => {
        this.detailForm = response.data
        this.detailForm.soleKey = this.detailForm.soleKey ? this.detailForm.soleKey.join(',') : ''
        this.openDetail = true
      });
    },
    // 关闭查看详情弹框
    closeDetail() {
      this.openDetail = false
    },
    handleDownloadRawData(row) {
      rawProjectDownloadRawData(row.id).then(response => {
        const url = response && response.data
        if (!url) {
          // this.$message.error('暂未获取到原始数据下载地址')
          return
        }
        if (url.indexOf('https://pan.baidu.com') !== -1) {
          window.open(url)
        } else {
          this.downLoadRawUrl = url
          this.downRawFilesDialog = true
        }
      }).catch(() => {
        // this.$message.error('获取原始数据下载地址失败')
      })
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      const id = row.id
      getProject(id).then(response => {
        this.selectDetail = response.data
        this.editProjectDialog = true
      });

    },
    //提交修改项目信息
    submitEditProject(data, file, type) {
      this.editProjectDialog = false
      if (type !== 'cancel') {
        this.isShowAddLoading = true
        if (file) {
          startUploadFile(file).then(res => {
            if (res.flag) {
              this.addResZip(file, data.id, res.fileMd5).then(flag => {
                if (flag) {
                  data.reportFileHash = res.fileMd5
                  data.reportPath = file.name
                  this.updateProject(data)
                } else {
                  this.$message.error("修改失败")
                }
              })
            } else {
              this.isShowAddLoading = false
              this.$message.error('文件上传失败')
            }
          })
        } else {
          this.updateProject(data)
        }
      }
    },
    //添加结题报告
    addResZip(file, id, hash) {
      return new Promise((resolve, reject) => {
        let sendData = {
          fileMd5: hash,
          fileName: file.name
        }
        addProjectFile(sendData, id).then(res => {
          if (res.code === 200) {

            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    //请求更新项目信息
    updateProject(data) {
      this.isShowAddLoading = false
      data.salesList = null
      data.creator = null
      updateProject(data).then(response => {
        if (response.code === 200) {
          this.isUpdate = false
          this.open = false;
          this.$message.success("修改成功");
          this.getData();
        } else {
          this.$message.error("修改失败");
        }
      });
    },
    //提交项目信息的修改
    async updateCustomerRemark(data) {
      let sendData = {projectId: data.projectId}
      Object.keys(data.form).forEach(key => {
        sendData[key] = data.form[key].value
      })
      let res
      if (data.form.hasOwnProperty('customerRemark')) {
        res = await projectCustomerEdit(sendData)
      }else {
        res = await updateProject(sendData.projectId,sendData.note?sendData.note:' ')
      }

      this.showUpdateDialog = false
      if (res) {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.$nextTick(() => {
            this.getData()
          })

        } else {
          this.$message.error('修改失败')
        }
      }
    },

    //点击修改项目类型
    handleShowUpdateDialog(project, type) {
      this.updateProjectData.projectId = project.id
      this.updateProjectData.title = '编辑信息'
      this.updateProjectData.form = {}
      switch (type) {
        case 'note':
          this.updateProjectData.title = '编辑备注'
          this.updateProjectData.form.note = {
            value: project.remark,
            type: 'textarea',
            label: '备注'
          }
          break;
        case 'customerRemark':
          this.updateProjectData.title = '编辑备注'
          this.updateProjectData.form.customerRemark = {
            value: project.customerRemark,
            type: 'textarea',
            label: '备注'
          }
          break;
        case 'category':
          this.updateProjectData.title = '编辑类型'
          this.updateProjectData.form.note = {
            value: project.projectsRow.category,
            type: 'input',
            label: '类型'
          }
          break;
      }
      this.showUpdateDialog = true
    },

    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirmUi('您确认要删除项目编号为"' + ids + '"的数据项？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return delProject(ids);
      }).then(() => {
        this.getData();
        this.$message.success("删除成功");
      }).catch(() => {
      });
    },
    /** 更换用户按钮操作 */
    handleChange(row) {
      this.updateProjectUserData.selectedSalers = row.salesList.map(item => {
        return item.uuid
      })
      this.updateProjectUserData.selectedCustomers = row.customerList.map(item => {
        return item.emailAccount
      })
      this.updateProjectUserData.selectedCustomersInfo = row.customerList
      this.updateProjectUserData.selectedAnalyze = row.creator ? row.creator.uuid : ''
      this.updateProjectUserData.projectId = row.id
      this.showUserDialog = true
    },
    // 请求释放原始数据
    handleAudit(row) {
      if (row.auditStatus === 0) {
        auditData(row.id).then(response => {
          if (response.code === 200) {
            this.getData()
            this.$message.success("释放成功");
          }
        })
      } else {
        this.$messageUi.error("释放失败，该数据已被释放");
      }
    },
    //下载报告
    handleDown(row) {
      getReportLink(row.id).then(res => {
            if (res?.code === 200) {
                const url = res.data
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink)
            }
      })
    },
    //更多下拉框
    handleCommand(command, row) {
      switch (command) {
        case "handleDown":
          this.handleDown(row);
          break;
        case "handleDetail":
          this.handleDetail(row);
          break;
        case "handleDelete":
          this.handleDelete(row);
          break;
        case "handleChange":
          this.handleChange(row);
          break;
        case "handleShare":
          this.handleShare(row);
          break;
        default:
          break;
      }
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    //提交更换用户的信息
    submitProjectUser(data, type) {
      this.showUserDialog = false
      if (type !== 'cancel') {
        let sendData = {
          "projectId": data.projectId,
          "analystUuid": data.selectedAnalyze,
          "salesUuids": data.selectedSalers,
          "customerIds": data.customerIds
        }
        changeProjectUser(sendData).then(res => {
          if (res) {
            if (res.code === 200) {
              this.$message.success('修改成功')
              this.getData()
            }
          }
        })
      }
    },
    computerNote(text) {
      if (text) {
        if (text.length <= 30) {
          return text
        } else {
          return text.substring(0, 30)
        }
      } else {
        return ''
      }
    },
    judgeProjectLock(row) {
      if (['USER', 'SALES'].includes(this.$store.getters["right/getRole"])) {
        return row.bsReleased && row.resReleased
      } else {
        return true
      }
    },
    judgeProjectLockIcon(row) {
      return !(row.bsReleased && row.resReleased)
    },
    lookSampleInfo(row) {
      this.selectDetail = {
        projectId: row.id,
        platform: 'LUOCE',
        isNeedFilterSample: row.hasSampleNames,
        sampleNameList: row.sampleNames ? row.sampleNames : []
      }
      this.sampleInfoDialog = true
    },
    //跳转到具体的项目
    getProjectInfo(id) {
      window.open('/raw/data/info?id=' + id)
    },
    //分享项目
    handleShare(row) {
      this.selectDetail = {
        projectId: row.id,
        customerList: row.customerList
      }
      this.showShareCusDialog = true
    },
    //关闭分享
    closeShareCusDialog() {
      this.showShareCusDialog = false
    },


  }

}
</script>

<style scoped>

</style>
